import { render, staticRenderFns } from "./AthleteComparativeDataCard.vue?vue&type=template&id=08095c23&scoped=true&"
import script from "./AthleteComparativeDataCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataCard.vue?vue&type=style&index=0&id=08095c23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08095c23",
  null
  
)

export default component.exports